import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=ce8038ba&scoped=true"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8038ba",
  null
  
)

export default component.exports